export default (style)=>{
  return(`

    .WalletLogoS {
      background: none !important;
      border-radius: 8px !important;
      border: 1px solid transparent !important;
      box-shadow: none !important;
      height: 40px !important;
      width: 40px !important;
    }
  `)
}
